export const MEDICINE_CATEGORIES = {
  ANTI_INFLAMATORIOS: 1,
  FOTOTERAPICOS: 2,
  IMUNOBIOLOGICOS: 3,
  SISTEMICOS_TRADICIONAIS: 4,
  TOPICOS: 5,
  ANTI_HISTAMINICOS: 6,
  HIDRATANTES: 7,
  ANTIBIOTICOS: 8,
  OTHERS: 9,
}

export const MEDICINE_CATEGORIES_DA_SUMMARIZED_REMOVED_IDS = [5, 6, 7, 8]

export const MEDICINE_PERIODS = {
  POR_SEMANA: 'por semana',
  POR_DIA: 'por dia',
  CADA_N_SEMANAS: 'a cada (n) semanas',
}
